import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Room } from '../model/room';
import { Search } from '../model/search';
import { AppSettings } from '../const/app.consts';
import { MotorService } from '../services/motor.service';
import { Empresa } from '../model/empresa';

import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class RoomsService {

  private empresa: Empresa;

  //private readonly API = AppSettings.API_ENDPOINT + '/api/snippet/motor/search/496?data=%7B%22solicitante%22%3A%22%22%2C%22documento%22%3A%22%22%2C%22email%22%3A%22%22%2C%22telefone%22%3A%22%22%2C%22diarias%22%3A1%2C%22adultos%22%3A%221%22%2C%22totalAdultos%22%3A1%2C%22criancas%22%3A%220%22%2C%22totalCriancas%22%3A0%2C%22totalSuites%22%3A0%2C%22dataInicial%22%3A%2227%2F08%2F2019%22%2C%22dataFinal%22%3A%2228%2F08%2F2019%22%2C%22valorTotal%22%3A0%2C%22totalFormat%22%3A%22%22%7D';

  constructor(
    private readonly http: HttpClient,
    private readonly motorService: MotorService
  ) { 
    console.log("RoomsService.constructor()");
    this.motorService.empresaObservable.subscribe(empresa => this.empresa = empresa);
  }

  //lista em rooms os quatos disponíveis 
  async listarQuartosDisponiveis(search: Search) {
    const data = {
      diarias: 1,
      adultos: search.adultos,
      totalAdultos: search.adultos,
      criancas: search.criancas,
      totalCriancas: search.criancas,
      dataInicial: moment(search.dataInicial).format('DD/MM/YYYY'),
      dataFinal: moment(search.dataFinal).format('DD/MM/YYYY'),
      solicitante: "",
      documento: "",
      email: "",
      telefone: "",     
      totalSuites: 0,
      valorTotal: 0,
      totalFormat: ""
    }
    const API = AppSettings.API_ENDPOINT + '/api/snippet/motor/search/' + this.empresa.id + '?data=' + JSON.stringify(data);
    return this.http.get<Room[]>(API).toPromise();
  }

  //pesquisa de quartos diponíveis
  SearchRooms() {
    return this.http.get<Search[]>("");
  }
}
